import { createEndpoint } from "../createEndpoint";
import type { HttpClient } from "../httpClient";
import {
    BookingCallAuthCheckResponseSchema,
    SubmitBookingCallLeadResponseSchema,
    type BookingCallAuthCheckRequest,
    type BookingCallAuthCheckResponse,
    type SubmitBookingCallLeadRequest,
    type SubmitBookingCallLeadResponse,
} from "../schemas/booking-call-leads";

export function createPublicBookingCallLeadsApi(http: HttpClient, baseUrl: string) {
    const publicBaseUrl = `${baseUrl}/public/booking-call-leads`;

    return {
        checkAuth: createEndpoint<BookingCallAuthCheckResponse, BookingCallAuthCheckRequest>(http, "POST", "/check-auth", {
            base: publicBaseUrl,
            responseSchema: BookingCallAuthCheckResponseSchema,
        }),
        submit: createEndpoint<SubmitBookingCallLeadResponse, SubmitBookingCallLeadRequest>(http, "POST", "", {
            base: publicBaseUrl,
            responseSchema: SubmitBookingCallLeadResponseSchema,
        }),
    };
}

export type PublicBookingCallLeadsApi = ReturnType<typeof createPublicBookingCallLeadsApi>;
